module.exports = __webpack_public_path__ + "img/sand-decal-02.95fef1c8.png";